import React, { useEffect, useState } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import values from 'lodash/values';
import get from 'lodash/get';
// import EnterNameContainer from '../containers/OnBoarding/EnterNameContainer';
// import LanguageContainer from '../containers/OnBoarding/LanguageContainer';
// import ProfileConatiner from '../containers/Profile/ProfileContainer';
import { routeMap, Routes, stacks } from '../constants/RouterConstants';
// import SelectGenderContainer from '../containers/OnBoarding/SelectGenderContainer';
// import Test from '../containers/TestContainer';
// import UploadDocuments from '../containers/Profile/UploadDocuments';
// import EnterPhoneNumberContainer from '../containers/OnBoarding/EnterPhoneNumberContainer';
// import SelectProfilePicContainer from '../containers/OnBoarding/SelectProfilePicContainer';
// import EnterOtpContainer from '../containers/OnBoarding/EnterOtpContainer';
// import SelectCityContainer from '../containers/OnBoarding/SelectCityContainer';
// import SelectCurrentLocationContainer from '../containers/OnBoarding/SelectCurrentLocationContainer';
// import SelectQualificationContainer from '../containers/OnBoarding/SelectQualificationContainer';
// import SelectJobTimingPreferenceContainer from '../containers/OnBoarding/SelectJobTimingPreferenceContainer';
// import ConnectMitrasContainer from '../containers/OnBoarding/ConnectMitrasContainer';
// import ProfileSuccessContainer from '../containers/OnBoarding/ProfileSuccessContainer';
// import WorkExperienceContainer from '../containers/OnBoarding/WorkExperienceContainer';
// import MultipleJobsContainer from '../containers/OnBoarding/MultipleJobsContainer';
// import SelectMultipleSkillsContainer from '../containers/OnBoarding/SelectMultipleSkillsContainer';
// import WorkExperienceFormContainer from '../containers/OnBoarding/WorkExperienceFormContainer';
// import HomePageContainer from '../containers/HomePage/HomePageContainer';
import BootStrapContainer from '../containers/BootStrap/BootStrapContainer';
// import WhatsYourAgeContainer from '../containers/OnBoarding/WhatsYourAgeContainer';
// import HomeAddressContainer from '../containers/OnBoarding/HomeAddressContainer';
// import AreYouMarriedContainer from '../containers/OnBoarding/AreYouMarriedContainer';
// import JobJoiningDurationContainer from '../containers/OnBoarding/JobJoiningDurationContainer';
// import JDContainer from '../containers/JD/JDContainer';
// import ApplyJobContainer from '../containers/JD/ApplyJobContainer';
// import ApplyJobBikeContainer from '../containers/JD/ApplyJobBikeContainer';
// import ApplyJobDLContainer from '../containers/JD/ApplyJobDLContainer';
// import BikeNotAvailableContainer from '../containers/JD/BikeNotAvailableContainer';
// import DLNotAvailableContainer from '../containers/JD/DLNotAvailableContainer';
// import UploadRcContainer from '../containers/JD/UploadRcContainer';
// import ApplicationSentConatiner from '../containers/JD/ApplicationSentContainer';
// import ImageUploadContainer from '../containers/JD/ImageUploadContainer';
// import EditDocumentSafeContainer from '../containers/Profile/EditDocumentSafeContainer';
// import ExpectedSalaryContainer from '../containers/OnBoarding/ExpectedSalaryContainer';
// import MitraProfileContainer from '../containers/MitaProfile/MitraProfileContainer';
// import ApplyJobDocumentContainer from '../containers/JD/ApplyJobDocumentContainer';
// import NameAgeContainer from '../containers/JD/NameAgeContainer';
// import CaptchaContainer from '../containers/Captcha/CaptchaContainer';
import Animate from '../components/Animate';
// import { Navigation } from '../modules/Navigation';
// import AuthService from '../services/AuthService';
import PrivacyPolicyContainer from '../containers/Static/PrivacyPolicyContainer';
import TermsUseContainer from '../containers/Static/TermsUseContainer';
// import AppService from '../services/AppService';
// import ABTestService from '../services/ABTestService';
// import ABTests from '../constants/ABTests';
import ReferralContainer from '../containers/Referral/ReferralContainer';
import MyJobsListContainer from '../containers/MyJobsStatus/MyJobsListContainer';
import MyJobDetailContainer from '../containers/MyJobsStatus/MyJobDetailContainer';
import knowledgeCentreContainer from '../containers/knowledgeCentre/KnowledgeCentreContainer';
import mitraShotsContainer from '../containers/MitraShots/MitraShotsContainer';
import DynamicMitraPageContainer from '../containers/DynamicMitraPages/DynamicMitraPageContainer';
import OneCodeContainer from '../containers/OneCode/OneCodeContainer';
import MyJobListingForRejectedCandidatesContainer from '../containers/MyJobsStatus/MyJobListingForRejectedCandidatesContainer';
import WelcomePrayerContainer from '../containers/Prayer/WelcomeContainer';
import SelectFaithContainer from '../containers/Prayer/SelectFaithContainer';
import SelectGodContainer from '../containers/Prayer/SelectGodContainer';
import PrayerOfferingContainer from '../containers/Prayer/PrayerOfferingContainer';
import SavingsContainer from '../containers/SavingsCalculator/SavingsContainer';
import EarningsContainer from '../containers/SavingsCalculator/EarningsContainer';
import SavingsAmountContainer from '../containers/SavingsCalculator/SavingsAmountContainer';
import MitraTelecallerContainer from '../containers/MitraTelecaller/MitraTelecallerContainer';
import JobListings from '../components/Marketplace/JobListings';
import CityWiseJobs from '../components/Marketplace/CityWiseJobs';
import JobDescription from '../components/Marketplace/JobDescription';
import WelcomeScreen from '../components/Marketplace/WelcomeScreen';
import JobApplicationStatusContainer from '../components/Marketplace/JobApplicationStatus/JobApplicationStatusContainer';
import ContentVideo from '../components/ContentVideos/ContentVideo';
import AdditionalInformationForm from '../components/Marketplace/JobApplicationStatus/AdditionalInformationForm/AdditionalInformationForm';
import OTPScreen from '../components/Marketplace/JobApplicationStatus/OTPScreen/OTPScreen';
import AdditionalDetails from '../components/Marketplace/AdditionalDetails';
import SuccessfullyApplied from '../components/Marketplace/SuccessfullyApplied';
import FindingJobs from '../components/Marketplace/FindingJobs';
import NotificationDeeplinkManagement from '../components/Marketplace/NotificationDeeplinkManagement';

const AppRoute = () => {
  const location = useLocation();
  const [pageDirection, setPageDirection] = useState('left');
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [currentPathOrder, setCurrentPathOrder] = useState(
    values(routeMap).filter(({ pathname }) => pathname === location.pathname)[0]?.order
  );
  const currentKey = Math.random();
  useEffect(() => {
    const newPath = location.pathname;
    const newPathOrder = values(routeMap).filter(({ pathname }) => pathname === newPath)[0]?.order;
    if (newPath !== currentPath) {
      const direction = currentPathOrder < newPathOrder ? 'left' : 'right';
      setCurrentPath(newPath);
      setCurrentPathOrder(newPathOrder);
      setPageDirection(direction);
    }
  });

  // PREVENT GOING BACK TO ON-BOARDING FROM HOME PAGE
  // useEffect(() => {
  //   const routeMappingForNewPath = get(routeMap, location.pathname);
  //   if (currentPath === Routes.HOME_PAGE && routeMappingForNewPath?.stack === stacks.ON_BOARDING) {
  //     if (AuthService.getUserID()) {
  //       Navigation.push({ pathname: Routes.HOME_PAGE }, true);
  //     }
  //   } else if (
  //     currentPath === Routes.SELECT_QUALIFICATION &&
  //     location.pathname === Routes.LANGUAGE_SELECTION
  //   ) {
  //     const llpFlag = AppService.getLanguageLandingPageFlag();
  //     const inNewLandingPageTreatmentGroup =
  //       ABTestService.getABTestVariant(ABTests.NEW_LADING_PAGE_TEST.name) ===
  //       ABTests.NEW_LADING_PAGE_TEST.variants[1];
  //     const stepsDontIncludeLanguageSelection = inNewLandingPageTreatmentGroup || llpFlag !== 'en';
  //     if (stepsDontIncludeLanguageSelection) {
  //       window.location.href = localStorage.getItem('initialUrl');
  //     }
  //   }
  // });

  return (
    <TransitionGroup className={`${pageDirection}`}>
      <CSSTransition key={currentKey} timeout={500} classNames="route">
        <Animate>
          <Route exact path="/" component={WelcomeScreen} />
          {/* <Route exact path={Routes.TEST} component={Test} /> */}
          {/* <Route exact path={Routes.PROFILE} component={ProfileConatiner} /> */}
          {/* <Route exact path={Routes.LANGUAGE_SELECTION} component={LanguageContainer} /> */}
          {/* <Route exact path={Routes.UPLOAD_DOCUMENTS} component={UploadDocuments} /> */}
          {/* <Route exact path={Routes.ENTER_NAME} component={EnterNameContainer} /> */}
          {/* <Route exact path={Routes.SELECT_GENDER} component={SelectGenderContainer} /> */}
          {/* <Route exact path={Routes.ENTER_PHONE_NUMBER} component={EnterPhoneNumberContainer} /> */}
          {/* <Route exact path={Routes.SELECT_PROFILE_PICTURE} component={SelectProfilePicContainer} /> */}
          {/* <Route exact path={Routes.ENTER_OTP} component={EnterOtpContainer} /> */}
          {/* <Route exact path={Routes.SELECT_CITY} component={SelectCityContainer} /> */}
          {/* <Route */}
          {/*  exact */}
          {/*  path={Routes.SELECT_CURRENT_LOCATION} */}
          {/*  component={SelectCurrentLocationContainer} */}
          {/* /> */}
          {/* <Route */}
          {/*  exact */}
          {/*  path={Routes.SELECT_QUALIFICATION} */}
          {/*  component={SelectQualificationContainer} */}
          {/* /> */}
          {/* <Route */}
          {/*  exact */}
          {/*  path={Routes.SELECT_JOB_PREFERENCE} */}
          {/*  component={SelectJobTimingPreferenceContainer} */}
          {/* /> */}
          {/* <Route exact path={Routes.CONNECT_MITRAS} component={ConnectMitrasContainer} /> */}
          {/* <Route exact path={Routes.PROFILE_SUCCESS} component={ProfileSuccessContainer} /> */}
          {/* <Route exact path={Routes.WORK_EXPERIENCE} component={WorkExperienceContainer} /> */}
          {/* <Route exact path={Routes.MULTIPLE_JOBS} component={MultipleJobsContainer} /> */}
          {/* <Route exact path={Routes.MULTIPLE_SKILLS} component={SelectMultipleSkillsContainer} /> */}
          {/* <Route exact path={Routes.WORK_EXPERIENCE_FORM} component={WorkExperienceFormContainer} /> */}
          {/* <Route exact path={Routes.HOME_PAGE} component={HomePageContainer} /> */}
          {/* <Route exact path={Routes.WHATS_YOUR_AGE} component={WhatsYourAgeContainer} /> */}
          {/* <Route exact path={Routes.SELECT_HOME_LOCATION} component={HomeAddressContainer} /> */}
          {/* <Route exact path={Routes.ARE_YOU_MARRIED} component={AreYouMarriedContainer} /> */}
          {/* <Route exact path={Routes.JOINING_DURATION} component={JobJoiningDurationContainer} /> */}
          {/* <Route exact path={Routes.JD} component={JDContainer} /> */}
          {/* <Route exact path={Routes.APPLY_JOB} component={ApplyJobContainer} /> */}
          {/* <Route exact path={Routes.APPLY_JOB_BIKE} component={ApplyJobBikeContainer} /> */}
          {/* <Route exact path={Routes.APPLY_JOB_DL} component={ApplyJobDLContainer} /> */}
          {/* <Route exact path={Routes.BIKE_NOT_AVAILABLE} component={BikeNotAvailableContainer} /> */}
          {/* <Route exact path={Routes.DL_NOT_AVAILABLE} component={DLNotAvailableContainer} /> */}
          {/* <Route exact path={Routes.UPLOAD_RC} component={UploadRcContainer} /> */}
          {/* <Route exact path={Routes.APPLICATION_SUCCESS} component={ApplicationSentConatiner} /> */}
          {/* <Route exact path={Routes.IMAGE_UPLOAD} component={ImageUploadContainer} /> */}
          {/* <Route exact path={Routes.EDIT_DOCUMENT_SAFE} component={EditDocumentSafeContainer} /> */}
          {/* <Route exact path={Routes.EXPECTED_SALARY} component={ExpectedSalaryContainer} /> */}
          {/* <Route exact path={Routes.MITRA_PROFILE} component={MitraProfileContainer} /> */}
          {/* <Route exact path={Routes.APPLY_JOB_DOC} component={ApplyJobDocumentContainer} /> */}
          {/* <Route exact path={Routes.USER_DETAILS} component={NameAgeContainer} /> */}

          {/* PRIVACY POLICY & TERMS OF USE */}
          <Route exact path={Routes.PRIVACY_POLICY} component={PrivacyPolicyContainer} />
          <Route exact path={Routes.TERMS_OF_USE} component={TermsUseContainer} />
          <Route exact path={Routes.REFERRAL} component={ReferralContainer} />

          <Route exact path={Routes.NON_PAYROLL_LANDING_PAGE} component={MyJobsListContainer} />
          <Route exact path={Routes.MY_JOBS_STATUS} component={MyJobsListContainer} />
          <Route exact path={Routes.MY_JOB_STATUS_DETAILS} component={MyJobDetailContainer} />
          <Route exact path={Routes.KNOWLEDGE_CENTRE} component={knowledgeCentreContainer} />
          <Route exact path={Routes.ONE_CODE} component={OneCodeContainer} />
          <Route exact path={Routes.MITRA_SHOTS} component={mitraShotsContainer} />
          <Route path={Routes.DYNAMIC_MITRA_PAGE} component={DynamicMitraPageContainer} />
          <Route
            exact
            path={Routes.MY_JOB_LISTING_For_REJECTED_CANDIDATES}
            component={MyJobListingForRejectedCandidatesContainer}
          />
          <Route exact path={Routes.WELCOME_PRAYER} component={WelcomePrayerContainer} />
          <Route exact path={Routes.SELECT_FAITH} component={SelectFaithContainer} />
          <Route exact path={Routes.SELECT_GOD} component={SelectGodContainer} />
          <Route exact path={Routes.PRAYER_OFFERING} component={PrayerOfferingContainer} />
          <Route exact path={Routes.SELECT_EARNINGS} component={EarningsContainer} />
          <Route exact path={Routes.SELECT_SAVINGS} component={SavingsContainer} />
          <Route exact path={Routes.SAVINGS_AMOUNT} component={SavingsAmountContainer} />
          <Route exact path={Routes.MITRA_TELECALLER} component={MitraTelecallerContainer} />
          <Route exact path={Routes.JOB_LISTINGS} component={JobListings} />
          <Route exact path={Routes.SELECT_CITY_WISE_JOBS} component={CityWiseJobs} />
          <Route exact path={Routes.JOB_DESCRIPTION} component={JobDescription} />
          <Route exact path={Routes.MARKETPLACE_WELCOME_SCREEN} component={WelcomeScreen} />
          <Route exact path={Routes.APPLICATION_STATUS} component={JobApplicationStatusContainer} />
          <Route exact path={Routes.CONTENT_VIDEOS} component={ContentVideo} />
          <Route exact path={Routes.ADDITIONAL_INFO} component={AdditionalInformationForm} />
          <Route exact path={Routes.VALIDATE_OTP} component={OTPScreen} />
          <Route
            exact
            path={Routes.ADDITIONAL_DETAILS_FOR_BEST_JOB}
            component={AdditionalDetails}
          />
          <Route exact path={Routes.SUCCESSFULLY_APPLIED} component={SuccessfullyApplied} />
          <Route exact path={Routes.FINDING_JOBS} component={FindingJobs} />
          <Route exact path={Routes.NOTIFICATIONS} component={NotificationDeeplinkManagement} />
        </Animate>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default AppRoute;
